import React from 'react';

function DistributionPreview({ preview, onExecute, onCancel, loading }) {
  if (!preview || !preview.success) {
    return null;
  }

  const recipients = Object.values(preview.preview);
  const totalLeads = preview.leadCount;

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-900">
          Distribution Preview
        </h3>
        <div className="text-sm text-gray-600">
          {totalLeads} leads → {preview.recipientCount} recipients
        </div>
      </div>

      {/* Summary */}
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <p className="text-sm text-green-800">
          {preview.message}
        </p>
      </div>

      {/* Distribution Table */}
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Recipient
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Role
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Weight
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Lead Count
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                Percentage
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {recipients.map((recipient) => {
              const percentage = ((recipient.count / totalLeads) * 100).toFixed(1);

              return (
                <tr key={recipient.id}>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      {recipient.name}
                    </div>
                    <div className="text-xs text-gray-500">
                      {recipient.fullName}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className="badge bg-blue-100 text-blue-800">
                      {recipient.role}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center whitespace-nowrap">
                    <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-tenq-gold text-white font-semibold text-sm">
                      {recipient.weight}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center whitespace-nowrap">
                    <span className="text-lg font-semibold text-tenq-gold">
                      {recipient.count}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center whitespace-nowrap">
                    <div className="flex flex-col items-center">
                      <span className="text-sm font-medium text-gray-900">
                        {percentage}%
                      </span>
                      <div className="w-20 bg-gray-200 rounded-full h-2 mt-1">
                        <div
                          className="bg-tenq-gold h-2 rounded-full"
                          style={{ width: `${percentage}%` }}
                        ></div>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot className="bg-gray-50">
            <tr>
              <td colSpan="3" className="px-4 py-3 text-right font-semibold text-gray-900">
                Total:
              </td>
              <td className="px-4 py-3 text-center font-bold text-lg text-tenq-gold">
                {totalLeads}
              </td>
              <td className="px-4 py-3 text-center font-semibold text-gray-900">
                100%
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Actions */}
      <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onExecute}
          disabled={loading}
          className="px-6 py-2 bg-tenq-gold text-white rounded-md hover:bg-tenq-gold-dark transition-colors disabled:opacity-50 font-semibold"
        >
          {loading ? 'Executing...' : 'Execute Distribution'}
        </button>
      </div>
    </div>
  );
}

export default DistributionPreview;
